import {Pipe,PipeTransform} from '@angular/core';
import { QaService } from "../services/qa.service";
import { QuestionTypeEnum } from "../models/question-type";
import { StartupService } from "../services/startup.service";

@Pipe({
    name:'variablePipe'
})

export class VariablePipe implements PipeTransform{
    transform(value: string) { 
        var projectTypeGuid = this.startupService.startupData.QuestionTypes.find(x=>x.Name == QuestionTypeEnum.ProjectType).ItemGuid;
        if(this.qaService.answers.selectedAnswers.length == 0)
            return value;
        else{
            return value.toLowerCase().replace('[variable]',this.qaService.answers.selectedAnswers.find(x=>x.QuestionType == projectTypeGuid).Title)
        }
            
    }
    constructor(private qaService : QaService,private startupService:StartupService){ }
}


// WEBPACK FOOTER //
// ./src/app/pipes/variable.pipe.ts